module.exports = __webpack_public_path__ + "img/imagem-planta-palmeiras04.41719f20.png";